import { useState, useEffect } from 'react';
import { subscribeToErrors, clearGlobalError } from '../redux/errorMiddleware';

/*
 * Gets global error state from RTK Query
 */
function useGlobalError() {
  const [error, setError] = useState({
    status: null,
    originalStatus: null,
    message: null,
  });

  useEffect(() => {
    const unsubscribe = subscribeToErrors(setError);
    return unsubscribe;
  }, []);

  return {
    error,
    clearError: clearGlobalError
  };
}

export default useGlobalError;
